import axios from "axios";
import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
// import { get, post } from "../../../../_helper/api_helper";
import { toast } from "react-toastify";
import { get, post } from "../../../_helper/api_helper";

const ADD_OR_UPDATE_DEDUCTION_PLAN_MASTER_RECORD = "DeductionPlanMaster/CreateOrUpdate";
const sliceName = "deductionPlan";

export const createOrUpdateDeductionPlanMaster = createAsyncThunk(
    ADD_OR_UPDATE_DEDUCTION_PLAN_MASTER_RECORD,
    async (payload) => {
        try {
            let response = await post(`${process.env.REACT_APP_API_DOTNET_URL}${ADD_OR_UPDATE_DEDUCTION_PLAN_MASTER_RECORD}`, payload);
            toast.success(`${payload?.id ? 'Updated' : 'Created'} successfully`);
            return { createResult: response?.data };
        } catch (error) {
            toast.error(`Invalid data!`);
            return { error }
        }
    }
);

export const getDeductionPlanById = createAsyncThunk(
    'DeductionPlanMaster/GetById',
    async (id) => {
        try {
            let response = await get(`${process.env.REACT_APP_API_URL_PR}DeductionPlanMaster/GetById/${id}`);
            return { data: response.data };
        } catch (error) {
            return { error }
        }
    }
);

export const resetDeductionPlan = createAsyncThunk('resetDeductionPlan', async () => {
    return {}
});

export const getDeductionPlans = createAsyncThunk(
    'getDeductionPlans',
    async () => {
        try {
            let response = await get(`${process.env.REACT_APP_API_URL_PR}DeductionPlanMaster/GetAll`);
            return { data: response.data };
        } catch (error) {
            return { error }
        }
    }
);

export const getDeductionTypes = createAsyncThunk(
    'getDeductionTypes',
    async () => {
        try {
            let response = await get(`${process.env.REACT_APP_API_URL_PR}deductionType/GetAll`,);
            return { data: response.data };
        } catch (error) {
            return { error }
        }
    }
);

export const getDeductionMethods = createAsyncThunk(
    'getDeductionMethods',
    async () => {
        try {
            let response = await get(`${process.env.REACT_APP_API_URL_PR}Enum/GetDeductionMethodList`);
            return { data: response };
        } catch (error) {
            return { error }
        }
    }
);

export const getAllPaymentTypes = createAsyncThunk(
    'getAllPaymentTypes',
    async () => {
        try {
            let response = await get(`${process.env.REACT_APP_API_URL_PR}PaymentType/GetAll`)
            return { data: response?.data };
        } catch (error) {
            return { error }
        }
    }
);

const deductionSlice = createSlice({
    name: sliceName,
    initialState: {
        createResult: {},
        isCreating: false,
        createError: {},
        isFetching: false,
        deductionPlan: {},
        error: {},

        isDeductionPlansFetching: false,
        deductionPlans: [],
        errorDeductionPlans: {},

        isDeductionTypesFetching: false,
        deductionTypes: [],
        errorDeductionTypes: {},

        isDeductionMethodsFetching: false,
        deductionMethods: [],
        errorDeductionMethods: {},

        isPaymentTypesFetching: false,
        paymentTypes: [],
        errorPaymentTypes: {},
    },
    extraReducers: (builder) => {
        builder
            .addCase(createOrUpdateDeductionPlanMaster.pending, (state) => { state.isCreating = true; })
            .addCase(createOrUpdateDeductionPlanMaster.fulfilled, (state, action) => {
                state.createResult = action.payload?.createResult;
                state.isCreating = false;
            })
            .addCase(createOrUpdateDeductionPlanMaster.rejected, (state, action) => {
                state.createResult = {};
                state.createError = action.payload?.error;
                state.isCreating = false;
            })
            .addCase(getDeductionPlanById.pending, (state) => { state.isFetching = true; })
            .addCase(getDeductionPlanById.fulfilled, (state, action) => {
                state.deductionPlan = action.payload?.data;
                state.isFetching = false;
            })
            .addCase(getDeductionPlanById.rejected, (state, action) => {
                state.deductionPlan = {};
                state.error = action.payload?.error;
                state.isFetching = false;
            })
            .addCase(getDeductionPlans.pending, (state) => { 
                state.deductionPlans= [];
                state.isDeductionPlansFetching = true; 
            })
            .addCase(getDeductionPlans.fulfilled, (state, action) => {
                state.deductionPlans = action.payload?.data;
                state.isDeductionPlansFetching = false;
            })
            .addCase(getDeductionPlans.rejected, (state, action) => {
                state.deductionPlans = [];
                state.errorDeductionPlans = action.payload?.error;
                state.isDeductionPlansFetching = false;
            })
            .addCase(getDeductionTypes.pending, (state) => { state.isDeductionTypesFetching = true; })
            .addCase(getDeductionTypes.fulfilled, (state, action) => {
                state.deductionTypes = action.payload?.data;
                state.isDeductionTypesFetching = false;
            })
            .addCase(getDeductionTypes.rejected, (state, action) => {
                state.deductionTypes = [];
                state.errorDeductionTypes = action.payload?.error;
                state.isDeductionTypesFetching = false;
            })
            .addCase(getDeductionMethods.pending, (state) => { state.isDeductionMethodsFetching = true; })
            .addCase(getDeductionMethods.fulfilled, (state, action) => {
                state.deductionMethods = action.payload?.data;
                state.isDeductionMethodsFetching = false;
            })
            .addCase(getDeductionMethods.rejected, (state, action) => {
                state.deductionMethods = [];
                state.errorDeductionMethods = action.payload?.error;
                state.isDeductionMethodsFetching = false;
            })
            .addCase(getAllPaymentTypes.pending, (state) => { state.isPaymentTypesFetching = true; })
            .addCase(getAllPaymentTypes.fulfilled, (state, action) => {
                state.paymentTypes = action.payload?.data;
                state.isPaymentTypesFetching = false;
            })
            .addCase(getAllPaymentTypes.rejected, (state, action) => {
                state.paymentTypes = [];
                state.errorDeductionMethods = action.payload?.error;
                state.isPaymentTypesFetching = false;
            })
            .addCase(resetDeductionPlan.fulfilled, (state, action) => {
                state.deductionPlan = {};
                state.isFetching = false;
            });
    },
});
export default deductionSlice.reducer;
